(function() {
	'use strict';

	angular.module('qbePortal').directive('qbRestrictInput', function() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function($scope, element, attr, ctrl) {
				// ng-trim must be set to false if you want to prevent whitespaces
				if (attr.ngTrim == 'false') {
					element.bind('keydown', function(e) {
						if (e.which === 32) {
							e.preventDefault();
							return false;
						}
					});
				}

				ctrl.$parsers.push(function(value) {
					var viewValue;
					var options = $scope.$eval(attr.qbRestrictInput);

					if (options.type) {
						switch (options.type) {
							case 'digitsOnly':
								viewValue = value.replace(/\D/g, '');
								break;
							case 'lettersAndDigitsOnly':
								viewValue = value.replace(/\W/g, '');
								break;
							case 'lettersAndDigitsSpaceOnly':
								if (/\s/g.test(value)) {
									viewValue = value.replace(
										/[^a-zA-Z0-9 ]/g,
										''
									);
								} else {
									viewValue = value.replace(/\W/g, '');
								}
								break;
							default:
								viewValue = '';
						}
					}

					if (viewValue !== value) {
						ctrl.$setViewValue(viewValue);
						ctrl.$render();
					}
					return viewValue;
				});
			}
		};
	});
})();
